import script from "./BoothCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoothCount.vue?vue&type=script&setup=true&lang=ts"

import "./BoothCount.vue?vue&type=style&index=0&id=49cd9058&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cd9058"]])

export default __exports__